import { FaWhatsapp } from "react-icons/fa";
import { MessageSquare, ShoppingBag, PackageCheck, CreditCard, ShieldCheck, Info } from "lucide-react";
import Seo from "@/components/Seo";
import { waLink, BNPL } from "@/lib/constants";

const STEPS = [
  { icon: ShoppingBag, title: "1. Pilih Produk", desc: "Telusuri katalog & tentukan produk beserta varian (warna/kapasitas) yang Anda inginkan." },
  { icon: MessageSquare, title: "2. Chat via WhatsApp", desc: "Klik tombol 'Beli via WhatsApp'. Nama produk otomatis terisi di pesan. Tim kami konfirmasi harga & stok terbaru." },
  { icon: CreditCard, title: "3. Pilih Pembayaran", desc: "Bayar tunai/transfer atau ajukan cicilan lewat Kredivo, Akulaku, Indodana, Yeskredit, atau kartu kredit." },
  { icon: PackageCheck, title: "4. Barang Dikirim", desc: "Setelah pembayaran dikonfirmasi, unit brand new bergaransi resmi kami kirim/serahkan ke Anda." },
];

export default function CaraPembelian() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-14 sm:px-6">
      <Seo title="Cara Beli & Cicilan" path="/cara-pembelian" description="Panduan cara membeli gadget di BigBerry Store dan opsi cicilan/BNPL: Kredivo, Akulaku, Indodana, Yeskredit, kartu kredit." />

      <p className="text-sm font-medium uppercase tracking-widest text-berry">Panduan</p>
      <h1 className="mt-1 font-heading text-4xl font-800 tracking-tight text-white">Cara Pembelian & Cicilan</h1>
      <p className="mt-3 max-w-2xl text-gray-400">
        Belanja di BigBerry Store simpel dan aman. Semua transaksi diarahkan closing via WhatsApp
        agar Anda mendapat harga terbaru serta bantuan langsung dari tim kami.
      </p>

      <div className="mt-10 grid gap-4 sm:grid-cols-2">
        {STEPS.map((s) => (
          <div key={s.title} className="rounded-2xl border border-white/5 bg-[#12141C] p-6">
            <div className="mb-4 inline-flex rounded-xl bg-berry/10 p-3 text-berry">
              <s.icon className="h-6 w-6" />
            </div>
            <h3 className="font-heading text-lg font-600 text-white">{s.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-gray-400">{s.desc}</p>
          </div>
        ))}
      </div>

      {/* Cicilan section */}
      <div className="mt-12 rounded-3xl border border-electric/30 bg-gradient-to-br from-electric/15 to-[#12141C] p-8 md:p-10">
        <span className="inline-flex items-center gap-2 rounded-full bg-electric/20 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-blue-300">
          <CreditCard className="h-4 w-4" /> Opsi Cicilan / BNPL
        </span>
        <h2 className="mt-4 font-heading text-2xl font-700 tracking-tight text-white md:text-3xl">Cicilan ringan, gadget di tangan lebih cepat</h2>
        <p className="mt-3 max-w-2xl text-gray-300">
          Kami mendukung berbagai metode pembayaran cicilan. Tenor & bunga mengikuti ketentuan
          masing-masing penyedia layanan. Konsultasikan simulasi cicilan Anda langsung ke tim kami
          via WhatsApp untuk info paling akurat.
        </p>
        <div className="mt-6 flex flex-wrap gap-2">
          {BNPL.map((b) => (
            <span key={b} className="rounded-lg border border-white/10 bg-white/5 px-4 py-2 text-sm font-medium text-white">{b}</span>
          ))}
        </div>
        <div className="mt-5 flex items-start gap-2 rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-gray-300">
          <Info className="mt-0.5 h-4 w-4 shrink-0 text-electric" />
          <span>Estimasi cicilan, syarat & ketentuan, serta persetujuan limit ditentukan oleh penyedia BNPL/bank. Tim BigBerry membantu proses pengajuan Anda.</span>
        </div>
      </div>

      <div className="mt-10 flex flex-col items-start gap-4 rounded-2xl border border-white/5 bg-[#12141C] p-8 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <ShieldCheck className="h-8 w-8 text-berry" />
          <div>
            <p className="font-heading text-lg font-600 text-white">Masih ada pertanyaan?</p>
            <p className="text-sm text-gray-400">Tim kami siap bantu dari pemilihan produk sampai cicilan.</p>
          </div>
        </div>
        <a href={waLink()} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full bg-whatsapp px-6 py-3 font-semibold text-white transition-colors hover:bg-whatsapp-dark">
          <FaWhatsapp className="h-5 w-5" /> Konsultasi Sekarang
        </a>
      </div>
    </div>
  );
}
